import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { FormRevisionSettingsDetailViewTopBar } from "./TopBar"

export const formRevisionSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: FormRevisionSettingsDetailViewTopBar,
}
